import { useRef, useEffect } from "react";
import jazzicon from "@metamask/jazzicon";
import { WalletDisplay } from "../wallet-display";
import { Address, WalletKey } from "@silo/types";
import { cn } from "../../utils/class-names";

interface AvatarProps {
  className?: string;
  account: Address;
  walletKey: WalletKey;
}

export function Avatar({
  className,
  walletKey,
  account,
}: AvatarProps): JSX.Element | null {
  return walletKey === "metaMask" ? (
    <Jazzicon account={account} className={cn("h-6 w-6", className)} />
  ) : (
    <WalletDisplay.Icon className="w-6 h-6" walletKey={walletKey} />
  );
}

interface JazziconProps {
  account: Address;
  className?: string;
}

function Jazzicon({ account, className }: JazziconProps): JSX.Element {
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const { current } = ref;

    if (current) {
      const icon = generateJazzicon(account);
      current.appendChild(icon);
    }

    return () => {
      if (!current) return;
      current.innerHTML = "";
    };
  }, [account]);

  return <span className={className} ref={ref} />;
}

const generateJazzicon = (account: Address): HTMLElement =>
  jazzicon(24, parseInt(account.slice(2, 10), 16));
